<template>
    <v-card  :to="(data.button.route)  ? data.button.route :data.button.link" class="bg-transparent rounded-0">
    <v-img
        :lazy-src="data.image.sizes.thumbnail"
        lazy
        :src="data.image.sizes.full"
        cover
        :aspect-ratio="21/9"
        :gradient="gradientColor[data.gradient]"
        :alt="data.image.title+' - '+data.image.description"
        class="mx-auto"
    >

        <v-container class="fill-height py-5">
            <v-row class="fill-height  px-5">
                <v-col cols="12"  align-self="end" class="text-start">
                    <h3 class="text-h5 text-lg-h4 text-shadow" v-html="data.title"></h3>
                    <h5 class="text-h6 text-lg-h5" v-if="data.sub_title" v-html="data.sub_title"></h5>
                    <v-hover >
                        <template v-slot:default="{ isHovering, props }">
                            <v-btn 
                                :to="(data.button.route)  ? data.button.route :data.button.link" 
                                class="btn-primelinks" 
                                v-bind="props"
                                variant="text" 
                                :class="isHovering ? '' : 'ps-0'" 
                                :color="data.button.color">
                                <span class="text-underline">{{data.button.text}}</span>
                                <v-icon class="ms-3">{{data.button.icon}}</v-icon>
                            </v-btn>
                        </template>
                    </v-hover>
                </v-col>
            </v-row>
        </v-container>
    </v-img>
    </v-card>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        gradientColor:{
            black: "to bottom, rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(18,18,18,0.51), rgba(18,18,18,1), rgba(0,0,0,1)",
            white: "to bottom, rgba(255,255,255,1), rgba(255,255,255,1), rgba(255,255,255,0.51), rgba(255,255,255,0.31), rgba(255,255,255,0.1), rgba(255,255,255,0.0), rgba(255,255,255,0.0), rgba(255,255,255,0.2),  rgba(255,255,255,0.51), rgba(255,255,255,1)",
            primary: "to bottom, rgba(179,148,127,1), rgba(179,148,127,1), rgba(179,148,127,0.51), rgba(179,148,127,0.31), rgba(179,148,127,0.1), rgba(179,148,127,0.0), rgba(179,148,127,0.0), rgba(179,148,127,0.2),  rgba(179,148,127,0.51), rgba(179,148,127,1)"
        }
    })
}
</script>